import { useContextState } from "../../../../../../hooks/theme"
import { assignColor } from "../../../../../../utils/methods/assignColor"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px 30px 20px 30px',
            borderBottom: `2px solid ${colors.color4}`,
            color: colors.color13
        },
        right: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        title: {
            fontWeight: '700',
            color: colors.color4,
            //fontSize: '14px'
        },
        porcentaje:({ porcentaje }: { porcentaje: number })=> {
            return {
                color: assignColor(porcentaje),
                fontSize: '23px',
                fontWeight: '700',
                marginRight: '15px',
                lineHeight: '1',
            }
        },
        completado: {
            fontSize: '23px',
            lineHeight: '1',
        }
        
    }
}

export { useStyles }